import type { SessionTemplate, SessionTemplateStep } from '@arrowise/shared';
import React from 'react'
import { createRoot } from 'react-dom/client'

let mountedRoot: { root: ReturnType<typeof createRoot>; container: HTMLDivElement } | null = null

export async function showTemplateDialog(template: SessionTemplate & { steps?: SessionTemplateStep[] }) {
    if (typeof window === 'undefined') return

    // dynamically import the dialog to keep it lazy
    const mod = await import('./TemplateViewDialog')
    const Component = mod?.default
    if (!Component) return

    if (!mountedRoot) {
        const container = document.createElement('div')
        container.setAttribute('data-template-dialog', 'true')
        document.body.appendChild(container)
        mountedRoot = { root: createRoot(container), container }
    }

    const { root } = mountedRoot

    function cleanup() {
        if (!mountedRoot) return
        try {
            root.unmount()
        } catch (e) {
            // ignore
        }
        if (mountedRoot.container.parentNode) mountedRoot.container.parentNode.removeChild(mountedRoot.container)
        mountedRoot = null
    }

    root.render(React.createElement(Component, { onClose: cleanup, template }))
}

export default showTemplateDialog
